import api from "../../../../api/axios";

export const getAllBuyers = async (params) => {
  try {
    const res = await api.get("/buyer", { params });
    return res?.data;
  } catch (err) {
    console.error("getAllBuyers error:", err);
    throw err;
  }
};

export const deleteBuyerListing = async (id) => {
  try {
    const res = await api.delete(`/buyer/${id}`);
    return res?.data;
  } catch (err) {
    console.error("deleteBuyerListing error:", err);
    throw err;
  }
};

export const getAllRefinance = async (params) => {
  try {
    const res = await api.get("/refinance", { params });
    return res?.data;
  } catch (err) {
    console.error("getAllRefinance error:", err);
    throw err;
  }
};

export const deleteRefinanceListing = async (id) => {
  try {
    const res = await api.delete(`/refinance/${id}`);
    return res?.data;
  } catch (err) {
    console.error("deleteRefinanceListing error:", err);
    throw err;
  }
};